/*
 * パスワードコンポーネント
 */
<template>
	<div>
		<div class="actionButton-area">
			<!--確定-->
			<!-- <button class="confirm-btn"
				v-on:click="onBtnConfirm" 
				v-bind="{'disabled': m_strPassword=='' || m_strErr != ''}" >
				{{r_messages.confirm_btn}}
			</button> -->
			<button class="confirm-btn"
				v-on:click="onBtnConfirm" 
				v-bind="{'disabled': m_strPassword=='' || m_strErr != ''}" >
				<i class="fa-solid fa-check"></i>
			</button>
		</div>
		<!--エラーメッセージ表示部-->
		<div v-if="m_strErr != '' " class="left error-messages"  >
			<!-- {{m_strErr}} -->
			<div v-html="m_strErr"></div>
		</div>
		<div v-else class="left empty-messages"  >
			{{disp_empty}}<!-- 空を設定 -->		　
		</div>

		<table class="detailed-list">
	<!-- パスワード -->
			<c-edittext
				ref="v_user_password"
				:r_messages = "r_messages"
				:r_settings = "r_settings"
				:r_validattype="m_typePassword"
				:r_placeholder="disp_pass_placeholder"
				:r_title = "r_pass_title"
				:r_max_length="r_max_length"
				:r_is_for_password="true"
				:r_is_width_half="true"
				v-model="m_strPassword"
				@blur="onBlurPassword"
				@event_change="onChangePassword"
				@changeDispPassword="onChangeDispPassword"
				@keyup="onKeyup" >
			</c-edittext>
	<!-- パスワード確認-->
			<c-edittext
				ref="v_user_password_confirm"
				:r_messages = "r_messages"
				:r_settings = "r_settings"
				:r_validattype="m_typePassword"
				:r_placeholder="disp_pass_placeholder"
				:r_title = "r_pass_confirm_title"
				:r_max_length="r_max_length"
				:r_is_width_half="true"
				v-model="m_strPasswordConfirm"
				@blur="onBlurPasswordConfirm"
				@event_change="onChangePasswordConfirm"
				@keyup="onKeyup" >
			</c-edittext>
		</table>
	</div>
</template>
<script>
	/**
	 * props 引数
	 * @param {string[]} r_url - URL
	 * @param {string[]} r_messages - 表示文言
	 * @param {string[]} r_settings - 初期設定値
	 * @param {string[]} is_new - 新規フラグ
	 * @param {object} r_info - 編集するデータ
	 **/
	 export default {
		mixins: [
			// setting
			require('js/common/vuex/setting/read.mixin.vue'),

			require('js/common/viewParamBase.mixin.vue'),
			// TABインデックス制御
			require('js/common/tabIndex.mixin.vue'),
		],
		props:{
			'r_pass_title': {
				type:String,
				default: ""
			},
			'r_pass_confirm_title': {
				type:String,
				default: ""
			},
			'r_max_length': {
				type:Number,
				default: 16
			},
		},
		data:function (){
			return{
				m_strPassword:"",
				m_strPasswordConfirm:"",
				m_strErr:"",
				m_typePassword: "password2",	// パスワード入力欄のタイプ
			};
		},
		created: function(){
			
		},
		/**
		 * @prop {bool} disp_changeFlag - 変更フラグをVuexを介して取得
		 * @prop {String} disp_textCode - 呼び出しコード
		 * @instance
		 **/
		computed: {
			// パスワード表示切替
			disp_pass_placeholder:function(){
				var password = " ";
				if(!this.r_is_new){
					password = this.r_messages.placeholder_password;
				}
				return password;
			},
			disp_empty:function(){
				return "　";
			},
		},
		// ----------------------------------------------------------------------------
		methods: {
			/** 
			 * パスワードフォーカスアウト処理
			 * 
			 * @function onBlurPassword
			 * 
			 */
			onBlurPassword: function(){
				// this.validatePassword();
			},
			/**
			 * パスワードの変更
			 *
			 * @function onChangePasswordConfirm
			 *
			 */
			onChangePassword: function(e){
				this.m_strErr = "";
			},
			/**
			 * パスワード確認のフォーカスアウト
			 *
			 * @function onBlurPasswordConfirm
			 *
			 */
			onBlurPasswordConfirm: function(e){
				// this.validatePassword();
			},
			/**
			 * パスワード確認の変更
			 *
			 * @function onChangePasswordConfirm
			 *
			 */
			onChangePasswordConfirm: function(e){
				this.m_strErr = "";
			},
			onBtnCancel:function(){
				this.$emit("event_cancel");
			},
			onBtnConfirm:function(){
				// if(this.validatePassword()) {
				// 	this.$emit("event_confirm",this.m_strPassword);
				// }

				var url =  this.manager.createCheckPasswordURL(this.m_strPassword, this.m_strPasswordConfirm);
				var callbackOK = function(rResponse) {
					if (rResponse.data.result == 0) {
						this.$emit("event_confirm", this.m_strPassword);
					}
				}.bind(this);
				var callbackNG = function(rResponse) {
					console.log("error! :");
					console.log(rResponse);
					var errors = rResponse.data.rec[0].errors;
					for (let i=0; i<errors.length; i++) {
						this.m_strErr += errors[i] + '<br>';
					}
				}.bind(this);
				this.manager.access(url, callbackOK, callbackNG);
			},
			/** 
			 * パスワードのバリデーション
			 */
			validatePassword: function(){
				this.m_strErr="";
				if(this.m_strPassword != this.m_strPasswordConfirm) {
					this.m_strErr = this.r_messages.error_password_confirmed;
					return false;
				}
				return true;
			},
			/**
			 * パスワード表示変更
			 */
			onChangeDispPassword: function(val) {
				this.m_typePassword = (val == 0) ? "password2" : "half-width-mark";
			},
		},
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/viewPassword.vue